import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Button, Label, Popup } from 'semantic-ui-react';
import GConf from 'AssetsM/generalConf';
import { useTranslation, Trans } from 'react-i18next';
import detectRTL from 'rtl-detect';
import { authService } from "core/auth/authService.js";

function LeftSideCard({ collapsed = false , onToggle  }) {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const isRTL = detectRTL.isRtlLang(i18n.language);
    const [session, setSession] = useState(() => authService.getSession());

    const LogOut = () =>{
        //localStorage.clear();
        localStorage.removeItem(`PID`);
        window.location.href = "/login";
    }

    const  capitalizeFirstLetter = (string) =>{
        return (string.charAt(0).toUpperCase() + string.slice(1)).charAt(0);
    }

    // Reusable nav item so icon/label logic isn't repeated per-link
    const NavItem = ({ to, icon, labelKey }) => {
        const link = (
            <NavLink
                to={to}
                exact="true"
                className={() => collapsed
                    ? "abyedh-list list-group-item list-group-item-action text-center py-2"
                    : "ps-1 pe-1 abyedh-list list-group-item list-group-item-action"
                }
            >
                <i className={`bi ${icon} ${collapsed ? '' : 'me-2'}`} style={{color: "var(--erp-primary)"}}></i>
                {!collapsed && t(labelKey)}
            </NavLink>
        );

        // Show a tooltip with the label when collapsed, since text is hidden
        return collapsed ? (
            <Popup
                content={t(labelKey)}
                position='right center'
                trigger={link}
                mouseEnterDelay={200}
            />
        ) : link;
    };

    return (  <>
            <div
                className={`col-12 ${collapsed ? 'col-lg-collapse-sm' : 'col-lg-2'} text-center d-none d-lg-block fixed-top border-end bg-white`}
                style={{backgroundColor: 'transparent', height:'100vh', zIndex: 2, top:'60px', transition: 'all 0.25s ease', overflow: 'hidden'}}
            >   
                <Button
                     
                    icon={collapsed ? 'angle right' : 'angle left'}
                    size='mini'
                    style={{ position: 'absolute', top: '10px', right: '-9px', zIndex: 10 }}
                    onClick={onToggle}
                />
                <h1 className={`text-white ${collapsed ? 'mt-5' : 'mt-0'} `}>
                    <img
                        src={`https://cdn.abyedh.com/images/ads/${session.system.id}.svg`}
                        alt="."
                        className="p-0 mt-2"
                        width={collapsed ? "40px" : "120px"}
                        height={collapsed ? "40px" : "120px"}
                        style={{transition: 'all 0.25s ease'}}
                    />
                </h1>
                <NavLink to='Profile' exact="true">
                    <div className={`card p-2 border-div button-dark shadow-sm m-2 ${collapsed ? 'px-0' : ''}`}>
                        <div className='row'>
                            <div className={`${collapsed ? 'col-12' : 'col-2'} align-self-center text-center`}>
                                <Label size='medium' color='teal' key={1}>
                                    <h4>{capitalizeFirstLetter(session.user_data.Name)}</h4>
                                </Label>
                            </div>
                            {!collapsed && (
                                <div className='col-10 align-self-center text-start text-truncate' style={{maxWidth : '90%'}}>
                                    {session.user_data.Name}
                                </div>
                            )}
                        </div>
                    </div>
                </NavLink>
                <div className='parent-div' style={{ position: 'relative', height: '100%' }}>
                        <div
                            className='child-div bg-white'
                            style={{
                                position: 'fixed',
                                bottom: 0,
                                width: collapsed ? '4.90%' : '16.50%', // matches col-lg-1 / col-lg-2
                                transition: 'width 0.25s ease'
                            }}
                        >
                            <div className={`list-group list-group-flush ${collapsed ? '' : 'text-start ps-1'}`}>
                                <NavItem to='Parametre' icon='bi-sliders' labelKey='menusAndTabsName.leftBar.parametre' />
                                <NavItem to='tools' icon='bi-tools' labelKey='menusAndTabsName.leftBar.tools' />
                                <NavItem to='forum' icon='bi-chat-square-dots' labelKey='menusAndTabsName.leftBar.forum' />
                                <NavItem to='messages' icon='bi-envelope-heart' labelKey='menusAndTabsName.leftBar.message' />
                                <NavItem to='support' icon='bi-headset' labelKey='menusAndTabsName.leftBar.documentation' />
                            </div>
                        </div>
                    </div>
            </div>
        </>
        );
}

export default LeftSideCard;